import {Controller} from '@hotwired/stimulus';
import {useIntersection} from 'stimulus-use';
import device from '../../js/device';
import {hasIntersectionObserver} from '../../js/window-has';

/* stimulusFetch: 'lazy' */
export default class extends Controller {

    static values = {
        url: String,
        rendering: Boolean,
        affiliateStyles: {type: Array, default: []},
        page: Number
    }

    async connect() {
        if (hasIntersectionObserver()) {
            useIntersection(this, {
                rootMargin: "100%",
            })
        } else {
            await this.appear()
        }

        // in desktop enable ultima ora articles
        if (device.getType() === 'desktop') {
            this._enableUltimaOraArticles();
            return false
        }
    }

    async appear() {

        if (device.getType() !== 'mobile') {
            return false
        }

        // if in rendering old iteration
        if (this.renderingValue === true) {
            return;
        }

        this.renderingValue = true;

        const params = new URLSearchParams({
            page: this.pageValue
        });

        const response = await fetch(`${this.urlValue}?${params.toString()}`);

        // error
        if (!response?.ok) {
            return;
        }

        if (response.status === 204) {
            this._enableUltimaOraArticles();
            this.element.remove();
            return;
        }


        if (response.headers.get('X-Has-Affiliation-Link') === 'true' || response.headers.get('X-Has-Youtube-Embed') === 'true') {
            this.affiliateStylesValue.forEach((e) => {
                let style = document.createElement('link');
                style.rel = 'stylesheet';
                style.crossorigin = 'anonymous';
                style.href = e;
                let node = document.getElementsByTagName('script')[0];
                node.parentNode.insertBefore(style, node);
            })
        }


        let text = await response.text()
        this.element.insertAdjacentHTML('beforebegin', text)

        this.pageValue++;
        this.renderingValue = false;

        // if there is a twitter embed
        if (text.includes("platform.twitter.com")) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//platform.twitter.com/widgets.js';
            let node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(script, node);
        }


        // if there is an instagram embed
        if (text.includes("instagram-media")) {
            try {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = '//www.instagram.com/embed.js';
                let node = document.getElementsByTagName('script')[0];
                node.parentNode.insertBefore(script, node);

                window.instgrm.Embeds.process()
            } catch (e) {
                console.log(e)
            }
        }

    }

    _enableUltimaOraArticles() {

        //const x = this.element.parentNode.querySelectorAll("div.ultima-ora")
        const x = document.getElementById("ultima-ora-articles-controller");
        if (x) {
            x.setAttribute('data-lists--ultima-ora-rendering-value', 'false')
        }
    }
}